import React from "react";
import {observer} from "mobx-react";
import {AgencyPage} from "../agency.page";
import {AgencyContactInformationViewComponent} from "./components/contact-information/agency-contact-information-view.component";
import {useServices} from "../../../hooks/use-services.hook";
import styled from "styled-components";
import {AgencyAccountViewComponent} from "./components/account-settings/agency-account-view.component";
import {AgencyProfileSectionComponent} from "./components/agency-profile-section.component";

const PageContentBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${props => props.theme.spacing.flexGap40};
    width: 70%;
    padding-bottom: ${props => props.theme.spacing.spacing30};
    flex-grow: 1;
    ${props => props.theme.screenMediaQuery.lAndBelow} {
        width: 90%;
    }
    ${props => props.theme.screenMediaQuery.smallScreen} {
        width: 100%;
    }
`


export const AgencyProfilePage: React.FC = observer(() => {
    const services = useServices();
    const userProfile = services.user.profile;

    const onChangePassword = async () => {
        await services.user.changePassword();
    }

    const onEditContactInformation = async () => {
        await userProfile.getEditor().editContactInformation();
    }

    return (
        <AgencyPage>
            <PageContentBox>
                <AgencyProfileSectionComponent title={services.language.translate('Account settings')}
                                               editButtonContent={services.language.translate('Change password')}
                                               onEditButtonClick={onChangePassword} >
                    <AgencyAccountViewComponent/>
                </AgencyProfileSectionComponent>
                <AgencyProfileSectionComponent title={services.language.translate('Contact information')}
                                               editButtonContent={services.language.translate('Edit')}
                                               onEditButtonClick={onEditContactInformation}>
                    <AgencyContactInformationViewComponent/>
                </AgencyProfileSectionComponent>
            </PageContentBox>

        </AgencyPage>
    );
})